import z from "zod";

export const OpeningBalanceFormSchema = z.object({
    openingBalance: z.number().optional(),
    clearingAccountId: z.string().uuid().optional(),
    adjustment: z.number().optional(),
    adjustmentClearingAccountId: z.string().uuid().optional(),
});

export type OpeningBalanceForm = Partial<
    z.infer<typeof OpeningBalanceFormSchema>
>;

export function shouldCreateJournalEntry(values: OpeningBalanceForm) {
    return (
        (typeof values.openingBalance === "number" &&
            values.openingBalance !== 0) ||
        (typeof values.adjustment === "number" && values.adjustment !== 0)
    );
}
